// External Imports
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

//Hooks
import { login } from '../utils/common';
import env from '../utils/env';

// Login Window
export default function StaffLogin({ setToken }) {
  // Local Data
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState({ message: '', severity: 'primary' });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError({ message: 'Processing...', severity: 'info' });

    login(username, password)
      .then((data) => {
        setToken(data.access_token);
        setError({ message: '', severity: 'success' });
      })
      .catch((error) => {
        if (error.message == 'Unauthorized') {
          setError({ message: 'Invalid username or password.', severity: 'warning' });
        } else if (error.message == 'Forbidden') {
          setError({ message: 'You do not have access to this portal.', severity: 'danger' });
        } else if (error.message == 'Authentication server unavailable') {
          setError({
            message: 'The authentication server is currently unavailable. Please try again later.',
            severity: 'danger',
          });
        } else {
          setError({
            message: 'Could not connect to the server. Please try again later.',
            severity: 'danger',
          });
        }
      });
  };

  return (
    <>
      <Row className='mb-3'>
        <Col>
          <h1 className='text-center'>{env('REACT_APP_COMPANY')} Customer Portal: Log In</h1>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col sm={{ span: 6, offset: 3 }}>
          <Card>
            <Card.Header>{env('REACT_APP_COMPANY')} Staff Log In</Card.Header>
            <Card.Body>
              {error.message !== '' && (
                <Alert variant={error.severity}>
                  <span>{error.message}</span>
                </Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <Form.Group as={Row} className='mb-3' controlId='username'>
                  <Form.Label column sm={3}>
                    Username
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      type='text'
                      placeholder='Enter Username'
                      name='username'
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className='mb-3' controlId='password'>
                  <Form.Label column sm={3}>
                    Password
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      type='password'
                      placeholder='Enter Password'
                      name='password'
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Col>
                </Form.Group>

                <Button variant='success' type='submit'>
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

StaffLogin.propTypes = {
  setToken: PropTypes.func,
};
